export const dbTabs2 = {
  ageRules: {
    heading: "Guest rules",
    headHint:
      "Define who counts as an infant, child or adult and how they count towards the capacity {scope}. By default, infants don't take a spot and aren't charged.",
    scopeHotel: "of each room",
    scopeApartment: "of the accommodation",
    loading: "Loading rules…",
    emptyHotel: "This hotel has no rooms set up.",
    capacityChipTitle: "Room capacity (set in Capacity)",
    slots: "{count} spot | {count} spots",
    badgeCustom: "Custom",
    badgeStandard: "Standard",
    applyAgeRules: "Apply age rules",
    masterSubHotel: "Custom infants, children and capacity for this room.",
    masterSubApartment: "Custom infants, children and capacity for this accommodation.",
    standardNote:
      "Standard behavior: infants don't count towards capacity and aren't charged.",
    capacityLabel: "Capacity",
    capacityGuestsNote:
      'guest · set in "Capacity"; these rules only adjust who counts | guests · set in "Capacity"; these rules only adjust who counts',
    infantUpTo: "Infants are up to",
    years: "years",
    childToAdult: "A child becomes an adult at",
    maxInfants: "Maximum infants",
    perBooking: "per booking",
    infantsOccupy: "Infants take a spot",
    infantsCharged: "Infants are charged",
    childrenCount: "Children count as a guest",
    ageLegend:
      "Infant: under {infant} years · Child: {infant}–{childTo} years · Adult: {adult}+ years.",
    listingCapacity: "Listing capacity",
    listingCapacityHint: 'Set in "Capacity" and shared with "Occupancy".',
    thisAccommodation: "This accommodation",
    loadError: "Couldn't load the guest rules.",
    saveSuccess: "Guest rules saved successfully.",
    saveError: "Couldn't save the guest rules.",
  },
  globalPayments: {
    title: "Global payments (Apartments/Villas)",
    pill: "Global",
    desc: "This setting applies to all of the user's apartment/villa properties.",
    loading: "Loading settings…",
    paymentType: "Payment type",
    onArrivalLabel: "Pay on arrival",
    onArrivalDesc: "The guest books and pays directly on arrival.",
    onlineLabel: "Online payment",
    onlineDesc: "The guest pays online when completing the booking.",
    savedAtUserLevel: "Saved at the user level for apartments/villas.",
    globalDiscount: "Global discount",
    enableGlobalDiscount: "Enable global discount",
    discountType: "Discount type",
    percentageLabel: "Percentage",
    percentageDesc: "Discount proportional to the total.",
    fixedLabel: "Fixed",
    fixedDesc: "Fixed amount to deduct.",
    valueTitle: "Value",
    phPercentage: "e.g. 10",
    phFixed: "e.g. 15.00",
    helpPercentage: "Up to 100%. Applied to the total.",
    helpFixed: "A fixed amount in {currency} is deducted.",
    previewTitle: "Preview",
    previewPercentage: "A {percent}% global discount will be applied.",
    previewFixed: "A global discount of {amount} will be applied.",
    appliesAllDirect: "Applies to all direct bookings for apartments/villas.",
    saveSuccess: "Global payments saved.",
    saveError: "Couldn't save the global payments.",
  },
  payments: {
    loading: "Loading settings…",
    q02Title: "When does the guest pay?",
    savingBadge: "Saving…",
    payOnArrivalName: "Pay on arrival",
    payOnArrivalHint: "The guest books and pays directly on arrival.",
    payOnlineName: "Online payment",
    payOnlineHint: "The guest pays online when completing the booking.",
    q03Title: "Time to pay",
    onlineOnlyBadge: "Online payment only",
    holdDesc:
      "The calendar is locked while the guest completes payment.<br>If they don't pay within the set time, <strong>availability is released automatically</strong>.",
    unitMin: "min",
    unitHour: "hour",
    unitHours: "hours",
    q04Title: "Partial payment",
    partialTitle: "Allow paying only part at booking",
    partialOnDesc:
      "<strong>On.</strong> The guest can pay <strong>{percent}%</strong> now and the rest before arrival (or pay in full).",
    partialOffDesc:
      "<strong>Off.</strong> The guest pays the <strong>full amount</strong> at booking.",
    blockTitle: "The rest is paid at the accommodation",
    blockOnDesc:
      "<strong>On.</strong> The guest pays <strong>only {percent}%</strong> online; the rest is settled <strong>on arrival</strong> (they can't pay in full online).",
    blockOffDesc:
      "<strong>Off.</strong> The guest can choose to pay {percent}% or the full amount online.",
    q05Title: "Balance reminder",
    reminderTitle: "Send a reminder to pay the outstanding balance",
    reminderOnDesc:
      "<strong>On.</strong> <strong>{when}</strong> arrival (around 09:00, property time) the guest is sent a link to pay the outstanding balance by <strong>WhatsApp and email</strong>.",
    reminderOffDesc:
      "<strong>Off.</strong> The guest doesn't get a reminder to pay the balance online before arrival.",
    daysBefore: "{count} day before | {count} days before",
    reminderDaysLabel: "Days before arrival",
    reminderHint:
      "Sent once, and only to guests with an outstanding balance. If the rest is paid at the accommodation, it isn't sent.",
    approveTitle: "Approve bookings",
    approveCardTitle: "Approve each booking before it's confirmed",
    approveOnDesc:
      "<strong>On.</strong> Each booking stays <strong>pending your approval</strong>: you get a notification and decide whether to accept or reject it. It isn't confirmed until you approve it.",
    approveOffDesc:
      "<strong>Off.</strong> Bookings <strong>confirm on their own</strong> once payment is completed. Turn it on if you prefer to review and approve each request yourself.",
    saveSuccess: "Saved.",
    saveError: "Couldn't save the changes.",
  },
  unitConfig: {
    descByRoom: "Description per room",
    descByRoomHint:
      "Each room has its own description and its own visibility in direct booking.",
    loadingRooms: "Loading rooms…",
    emptyHotel: "This hotel has no rooms set up.",
    visible: "Visible",
    hidden: "Hidden",
    roomDescPlaceholder: "Describe {name} (beds, amenities, views…)",
    savingDesc: "Saving…",
    autosaveHint: "Saved automatically when you leave the field.",
    loadingProperty: "Loading accommodation data…",
    loadErrorProperty: "Couldn't load this accommodation's settings.",
    amenitiesByRoom: "Amenities per room",
    amenitiesByRoomHint:
      "Each room can offer different amenities. Direct booking and the AI Agent use those of the room assigned to the guest.",
    amenitiesCount: "{count} amenity | {count} amenities",
    noAmenities: "No amenities",
    titleDescription: "Accommodation description",
    titleServices: "Equipment and amenities",
    subtitleDescription:
      "Edit the description guests will see on your direct booking page.",
    subtitleServices: "Mark what this property offers and upload its photos.",
  },
};
